import {createSelector} from "@reduxjs/toolkit";

export function selectFlat(key) {
  return createSelector(s => s[key], sk => Object.values(sk ?? {}));
};
